import React from "react";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import dayjs from "dayjs";
import "../../styles/CustomControls.css";

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

const CustomDataRangeSelect = ({
  selectedStartDate,
  setSelectedStartDate,
  selectedEndDate,
  setSelectedEndDate,
}) => {
  return (
    <div className="rbDateRangeField">
      <label>Date From – Date To</label>

      <div className="rbDateRangeInputs">
        <input
          type="date"
          value={
            selectedStartDate
              ? dayjs(selectedStartDate).format("YYYY-MM-DD")
              : ""
          }
          onChange={(e) =>
            setSelectedStartDate(e.target.value ? dayjs(e.target.value) : null)
          }
        />
        <span className="rbDateRangeSep">–</span>
        <input
          type="date"
          value={
            selectedEndDate ? dayjs(selectedEndDate).format("YYYY-MM-DD") : ""
          }
          onChange={(e) =>
            setSelectedEndDate(e.target.value ? dayjs(e.target.value) : null)
          }
        />
      </div>
    </div>
  );
};

export default CustomDataRangeSelect;
